import { Package, Bike, CheckCircle } from "lucide-react";

const steps = [
  {
    number: "1",
    title: "Request Pickup",
    desc: "Enter your pickup and drop-off details in seconds.",
    icon: <Package size={26} />,
  },
  {
    number: "2",
    title: "Track in Real-Time",
    desc: "Monitor your parcel with live GPS tracking.",
    icon: <Bike size={26} />,
  },
  {
    number: "3",
    title: "Delivered Safely",
    desc: "Your parcel is delivered quickly and securely to the recipient.",
    icon: <CheckCircle size={18} />,
  },
];

export default function HowItWorks() {
  return (
    <div className="py-16 px-10 bg-gray-50">
      {/* TITLE */}
      <div className="flex items-center justify-center mb-12">
        <div className="w-24 h-1 bg-orange-400"></div>
        <h2 className="mx-4 text-2xl font-bold text-gray-800">How It Works</h2>
        <div className="w-24 h-1 bg-orange-400"></div>
      </div>

      {/* CARDS */}
      <div className="grid md:grid-cols-3 gap-6">
        {steps.map((step, i) => {
          const isLast = i === 2;

          return (
            <div
              key={i}
              className="p-6 bg-white shadow-md rounded-lg hover:shadow-lg transition flex flex-col items-center"
            >
              {/* ICON */}
              <div className="mb-5">
                <div className="w-14 h-14 rounded-full bg-orange-100 flex items-center justify-center">
                  {isLast ? (
                    <div className="w-8 h-8 bg-green-800 rounded-sm flex items-center justify-center">
                      <CheckCircle size={14} className="text-white" />
                    </div>
                  ) : (
                    <div className="text-orange-500">{step.icon}</div>
                  )}
                </div>
              </div>

              {/* TEXT BLOCK */}
              <div className="w-[220px]">
                {/* NUMBER + TITLE */}
                <div className="flex items-center gap-3 mb-2">
                  <div className="bg-orange-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                    {step.number}
                  </div>

                  <h3 className="font-semibold text-lg text-gray-800">
                    {step.title}
                  </h3>
                </div>

                {/* DESCRIPTION ALIGNED WITH TITLE */}
                <p className="text-gray-500 text-sm ml-[2.75rem]">
                  {step.desc}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
